module.exports = __webpack_public_path__ + "static/img/corvette.52009a6.png";


//////////////////
// WEBPACK FOOTER
// ./src-detail/img/corvette.png
// module id = Hamk
// module chunks = 1